module.exports = __webpack_public_path__ + "static/media/Database Management System.3452e7b8.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CSE/Database Management System.pdf
// module id = 100
// module chunks = 0